import { Component, Input, OnChanges, OnInit, SimpleChanges, inject, input, model, output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { LayoutModel } from '../../shared/models/layout.model';
import { LocalstorageService } from '../../shared/services/localstorage.service';
import { User } from '../../shared/models/user.model';
import { ProfileService } from '../../profile/services/profile.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [MenubarModule, ButtonModule],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.css'
})
export class TopbarComponent implements OnInit, OnChanges {

  title = input<string>()

  profile = model<User | undefined>()
  logout = output<void>()

  visible = input.required<boolean>()

  visibleWithUser = model<boolean>(false);
  visibleWithNotUser = model<boolean>(true);
  sidebarVisible = output<boolean>();

  items!: MenuItem[];

  state: LayoutModel = {
    profileSidebarVisible: true,
  }

  styleClass: string = `topbar-menu topbar-menu-mobile-active`

  private overlayOpen = new Subject<any>()

  constructor(
    public router: Router,
    private localstorageService: LocalstorageService,
  ) {}

  private profileService = inject(ProfileService)

  ngOnInit(): void {
    // this.update();
    // this.updateItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.update();
    this.updateItems();
  }

  update() {
    // console.log('Update User: ', this.user())
    // console.log('User: ', this.visibleWithUser())
    // console.log('Not User: ', this.visibleWithNotUser())
    if (this.profile() !== undefined) {
      this.visibleWithUser.update((value) => (value = true));
      this.visibleWithNotUser.update((value) => (value = false));
    } else if (this.profile() === undefined) {
      this.visibleWithUser.update((value) => (value = false));
      this.visibleWithNotUser.update((value) => (value = true));
    }
  }

  updateItems(): void {
    this.items = [
      {
        label: 'Home',
        icon: 'pi pi-home',
        button: 'p-link topbar-button',
        route: '/',
      },
      {
        // label: 'Profile',
        label: 'Profile Description',
        icon: 'pi pi-user',
        button: 'p-link topbar-button',
        route: './profile/description',
      },
      {
        label: 'Login',
        icon: 'pi pi-sign-in',
        button: 'p-link topbar-button',
        route: './profile/login',
        visible: this.visibleWithNotUser(),
      },
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        button: 'p-link topbar-button',
        route: '/',
        visible: this.visibleWithUser(),
        command: () => {
          this.profileService.logout()
          this.profileService.validateProfile()
        }
      },
    ]
    // console.log('Menu Items: ', this.items[1].items)
  }


  sidebar():void {
    // console.log('visible: ', this.visible());
    if (this.profile() !== undefined) {
      const visible: boolean = !this.visible();
      this.sidebarVisible.emit(visible);
    } else {
      const visible: boolean = false;
      this.sidebarVisible.emit(visible);
    }
  }
}
